/* es5-ext/number/is-integer/shim.js */ function _(require, module, exports) {
    module.exports = function (value) {
        if (typeof value !== "number")
            return false;
        return value % 1 === 0;
    };
}
